module.exports = __webpack_public_path__ + "static/media/MHRP09N0002.ae7b183e.svg";